import * as React from 'react';
import SearchIcon from '@mui/icons-material/Search'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';


export default function SearchBar(props: {
  clickEvent: (text: string) => void
}) {

  const [text, setText] = React.useState("")

  return (
    <FormControl sx={{ m: 1 }}
      variant="standard"
      style={{
        width: "80%"
      }}
    >
      <TextField
        label="キーワード入力"
        variant="filled"
        color="success"
        focused
        value={text}
        onChange={(event) => setText(event.target.value)}
        size='medium'
        onKeyPress={e => {
          if (e.key === 'Enter') {
            props.clickEvent(text)
            setText("")
          }
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton onClick={() => { props.clickEvent(text); setText("") }}>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          )
        }}
      />
    </FormControl>
  );
}